import {SponsorBottomSheetProps} from '../type';
import {FormikContextType, useFormikContext} from 'formik';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import SponsorCustomButton from '../../CustomButton';
import useGetInitialSponsorInformation from '../../../../../services/hookService/sponsor/getInitialSponsorInformation/useGetInitialSponsorInformation';
import {initialValuesSponsorForm} from '../../../CreateActivePlan/type';

const WaterSystemBottomSheet = ({show, setShow}: SponsorBottomSheetProps) => {
  const {sponsorInfo, isLoading} = useGetInitialSponsorInformation();
  const formikProps: FormikContextType<initialValuesSponsorForm> =
    useFormikContext();
  return (
    <BottomSheet
      onDismiss={() => setShow(false)}
      open={show}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.8]}
      className="custom-bottom-sheet"
    >
      <div className="p-6 flex flex-col gap-[29px] text-gray-900">
        {/* start header bottom sheet */}
        <div className="flex items-center justify-between ">
          <h5>نوع آبیاری مزارع</h5>
          <SpanIcon
            className="icon-nameClose-remove text-gray-700 text-2xl"
            onClick={() => setShow(false)}
          />
        </div>
        {/* end header bottom sheet */}
        <ul className="space-y-2 overflow-y-scroll mb-0 pl-0 max-h-[60dvh]">
          {!isLoading &&
            sponsorInfo?.water_system.map((system, index) => {
              const isInArray = formikProps.values.water_system.some(
                item => item.id === system.id,
              );

              return (
                <li
                  className="flex items-center gap-1"
                  key={'sponser-message-item' + index}
                  onClick={() => {
                    if (isInArray) return;
                    const newData = [...formikProps.values.water_system];
                    newData.push({title: system.title, id: system.id});
                    formikProps.setFieldValue('water_system', newData);
                    formikProps.setFieldTouched('water_system', true);
                  }}
                >
                  <span
                    className={`w-3 h-3 !rounded !border ${
                      isInArray
                        ? 'bg-farm-shop-500 !border-farm-shop-500'
                        : 'bg-transparent !border-gray-800'
                    }`}
                  ></span>
                  <span>{system.title}</span>
                </li>
              );
            })}
        </ul>
        <div className="px-8">
          <SponsorCustomButton
            outline={false}
            buttonType="button"
            title="تأیید"
            handler={() => setShow(false)}
          />
        </div>
      </div>
    </BottomSheet>
  );
};
export default WaterSystemBottomSheet;
